import React from 'react';
import { useTranslation } from 'react-i18next';

// Language names are endonyms (a language's own name for itself) - "Norsk" and
// "English" stay as-is regardless of which UI language is active, same as any
// real language picker.
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const buttonStyle = (lang) => ({
    flex: 1,
    padding: '14px',
    borderRadius: 12,
    cursor: 'pointer',
    border: i18n.language === lang ? '2px solid #F5C400' : '1px solid #2A3870',
    background: i18n.language === lang ? '#1A2458' : 'transparent',
    color: '#F5F7FF',
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "'Syne', sans-serif",
  });

  return (
    <div style={{ display: 'flex', gap: 10 }}>
      <button type="button" onClick={() => i18n.changeLanguage('no')} style={buttonStyle('no')}>
        Norsk
      </button>
      <button type="button" onClick={() => i18n.changeLanguage('en')} style={buttonStyle('en')}>
        English
      </button>
    </div>
  );
}
